// Mock data for Den Cyber Solutions

export const companyInfo = {
  name: "Den Cyber Solutions",
  mission: "Your trusted partner in Governance, Risk, and Compliance - safeguarding businesses with practical security expertise that keeps threats at bay",
  slogan: "We keep the wolves from your door",
  email: "dbrennan@cyberden-solutions.com",
  phone: "",
  address: "London, United Kingdom",
  logo: "https://customer-assets.emergentagent.com/job_securepro-hub/artifacts/22t97nkl_logo%202.png"
};

export const services = [
  {
    id: 1,
    title: "Risk Assessments",
    description: "Comprehensive risk analysis to identify vulnerabilities and prioritize security measures for your organization.",
    icon: "AlertTriangle"
  },
  {
    id: 2,
    title: "Compliance Auditing",
    description: "Expert auditing services ensuring your organization meets ISO 27001, NIST, and other regulatory requirements.",
    icon: "FileCheck"
  },
  {
    id: 3,
    title: "Security Consulting",
    description: "Strategic guidance on implementing robust security frameworks and best practices tailored to your business.",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Penetration Testing",
    description: "Ethical hacking services to uncover security weaknesses before malicious actors can exploit them.",
    icon: "Lock"
  },
  {
    id: 5,
    title: "Network Security",
    description: "Protect your network infrastructure with advanced monitoring, threat detection, and incident response.",
    icon: "Network"
  },
  {
    id: 6,
    title: "Cloud Security",
    description: "Secure your cloud environments with comprehensive governance, risk management, and compliance solutions.",
    icon: "Cloud"
  }
];

export const frameworks = [
  {
    id: 1,
    title: "NIST RMF",
    fullName: "NIST Risk Management Framework",
    description: "The NIST Risk Management Framework provides a comprehensive, flexible approach to managing information security and privacy risk. We guide organizations through all seven steps: Prepare, Categorize, Select, Implement, Assess, Authorize, and Monitor.",
    benefits: [
      "Structured approach to cybersecurity",
      "Continuous monitoring and improvement",
      "Compliance with federal standards",
      "Integration with business processes"
    ],
    icon: "Shield"
  },
  {
    id: 2,
    title: "ISO 27001",
    fullName: "ISO/IEC 27001 Information Security Management",
    description: "ISO 27001 is the international standard for information security management systems (ISMS). We provide expert guidance and practical support to help organizations understand and work towards ISO 27001 compliance. With hands-on experience implementing this framework, we guide you through the process.",
    benefits: [
      "Expert guidance on ISO 27001 requirements",
      "Practical implementation support",
      "Gap analysis and readiness assessments",
      "Documentation and policy development"
    ],
    icon: "FileCheck"
  },
  {
    id: 3,
    title: "CCM",
    fullName: "Cloud Controls Matrix",
    description: "The Cloud Security Alliance's Cloud Controls Matrix provides a controls framework that gives detailed understanding of security concepts relevant to cloud computing. Essential for organizations using cloud services.",
    benefits: [
      "Cloud-specific security controls",
      "Alignment with industry standards",
      "Vendor risk assessment framework",
      "Multi-cloud security governance"
    ],
    icon: "Cloud"
  }
];

export const caseStudy = {
  title: "GB Plant Ltd - Risk Management & Security Assessment",
  client: "Irish Construction Company",
  industry: "",
  challenge: "The client needed to strengthen their information security posture and implement proper risk management processes. They had limited understanding of information security frameworks and required practical guidance.",
  solution: "We conducted a comprehensive gap analysis, developed tailored security policies, implemented NIST SP 800-37 risk management processes, and provided hands-on training to build internal security capabilities.",
  metrics: [
    { label: "Device Security", value: "100%", description: "of devices hardened with all patches up to date" },
    { label: "Security Confidence", value: "90%", description: "increase in confidence in online security" },
    { label: "Risk Reduction", value: "78%", description: "reduction in identified security vulnerabilities" }
  ],
  results: [
    "Implemented robust information security management system",
    "Established comprehensive risk assessment framework",
    "Staff trained on security best practices and NIST SP 800-37",
    "Strengthened overall security posture and risk management"
  ],
  testimonial: "Den Cyber Solutions transformed our approach to information security. Their practical expertise made complex frameworks understandable and achievable for our team.",
  clientName: "Project Director, GB Plant Ltd"
};

export const aboutInfo = {
  title: "Governance, Risk & Compliance Experts",
  description: "At Den Cyber Solutions, we specialize in helping SMEs and large enterprises navigate the complex landscape of cybersecurity. With over 15 years of experience implementing risk management frameworks, we provide practical, business-focused solutions that protect your organization and ensure compliance.",
  expertise: [
    "Over 15 years implementing risk management frameworks",
    "Deep expertise in NIST, ISO 27001, and CCM",
    "Proven track record with SMEs and enterprises",
    "Practical, business-focused approach"
  ],
  certifications: [
    { name: "CCSP Associate", expertise: "Cloud Security" },
    { name: "CompTIA PenTest+", expertise: "Penetration Testing" },
    { name: "CompTIA Security+", expertise: "Security Fundamentals" },
    { name: "CompTIA SecurityX", expertise: "Advanced Security" },
    { name: "CompTIA CySA+", expertise: "Cybersecurity Analytics" },
    { name: "CompTIA Network+", expertise: "Network Infrastructure" },
    { name: "Cisco CCNA Certified", expertise: "Network Administration" }
  ]
};
